var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { SignalWatcher } from "@lit-labs/preact-signals";
import { draft } from "../state";
let ModeSequence = class ModeSequence extends SignalWatcher(LitElement) {
    constructor() {
        super(...arguments);
        /** Codes to sequence (student_view supplies these, deterministically sorted). */
        this.unsequenced = [];
        /** Optional code -> description map for display. */
        this.descriptions = {};
        this.dragFrom = -1;
    }
    static { this.styles = css `
    :host, *, *::before, *::after { box-sizing: border-box; }
    :host { display: block; }
    .intro h2 { font-family: var(--font-display); font-size: 13px; font-weight: 700; margin: 0 0 3px;
                text-transform: uppercase; letter-spacing: .05em; color: var(--color-slate-700); }
    .intro .sub { font-size: 12px; color: var(--color-slate-500); margin-bottom: 12px; }
    .card { display: grid; grid-template-columns: 18px 26px 1fr auto; gap: 10px; align-items: center;
            padding: 10px; background: var(--color-white); border: 1px solid var(--color-slate-200);
            border-radius: var(--radius-md); margin-bottom: 6px; cursor: grab; }
    .card.drop-target { box-shadow: 0 -2px 0 0 var(--color-blue-600); }
    .handle { color: var(--color-slate-400); cursor: grab; font-size: 14px; user-select: none; }
    .seqno { font-weight: 700; color: var(--color-slate-400); font-size: 13px; text-align: center; }
    .body .code { font-family: var(--font-mono); font-weight: 700; color: var(--color-slate-900); font-size: 13px; }
    .body .desc { color: var(--color-slate-700); font-size: 13px; }
    .role-badge { display: inline-block; font-size: 10px; font-weight: 700; padding: 2px 6px; border-radius: 10px;
                  letter-spacing: .04em; text-transform: uppercase; margin-right: 6px;
                  background: var(--color-blue-600); color: white; }
    .arrows { display: flex; gap: 2px; }
    .arrows button { padding: 2px 6px; cursor: pointer; border: 1px solid var(--color-slate-300);
                     background: var(--color-white); border-radius: var(--radius-sm); font-size: 12px; }
    .arrows button:hover { background: var(--color-slate-50); }
  `; }
    willUpdate() {
        const d = draft.value;
        if (d && this.unsequenced.length && (!d.order || d.order.length === 0)) {
            draft.value = { ...d, order: [...this.unsequenced] };
        }
    }
    setOrder(order) {
        const d = draft.value;
        draft.value = { ...d, order };
    }
    move(code, delta) {
        const order = [...(draft.value?.order ?? [])];
        const i = order.indexOf(code);
        const j = i + delta;
        if (i < 0 || j < 0 || j >= order.length)
            return;
        [order[i], order[j]] = [order[j], order[i]];
        this.setOrder(order);
    }
    onDrop(to) {
        if (this.dragFrom < 0 || this.dragFrom === to)
            return;
        const order = [...(draft.value?.order ?? [])];
        const [moved] = order.splice(this.dragFrom, 1);
        order.splice(to, 0, moved);
        this.setOrder(order);
        this.dragFrom = -1;
    }
    render() {
        const order = (draft.value?.order) ?? [];
        return html `
      <div class="intro">
        <h2>Sequence the episode</h2>
        <div class="sub">Order the codes by clinical priority. The first becomes the Principal diagnosis. Drag rows or use the arrows.</div>
      </div>
      ${order.map((code, i) => html `
        <div class="card" draggable="true"
             @dragstart=${() => { this.dragFrom = i; }}
             @dragend=${() => { this.dragFrom = -1; }}
             @dragover=${(e) => e.preventDefault()}
             @drop=${(e) => { e.preventDefault(); this.onDrop(i); }}>
          <span class="handle" title="Drag to reorder">⋮⋮</span>
          <span class="seqno">${i + 1}</span>
          <div class="body">
            ${i === 0 ? html `<span class="role-badge">Principal Dx</span>` : ""}
            <span class="code">${code}</span>
            ${this.descriptions[code] ? html ` <span class="desc">${this.descriptions[code]}</span>` : ""}
          </div>
          <div class="arrows">
            <button data-up=${code} aria-label="Move ${code} up" @click=${() => this.move(code, -1)}>▲</button>
            <button data-down=${code} aria-label="Move ${code} down" @click=${() => this.move(code, 1)}>▼</button>
          </div>
        </div>`)}
    `;
    }
};
__decorate([
    property({ attribute: false })
], ModeSequence.prototype, "unsequenced", void 0);
__decorate([
    property({ attribute: false })
], ModeSequence.prototype, "descriptions", void 0);
__decorate([
    state()
], ModeSequence.prototype, "dragFrom", void 0);
ModeSequence = __decorate([
    customElement("mode-sequence")
], ModeSequence);
export { ModeSequence };
